<div class="sideNavbar">
  <div class="title" data-i18n="AppName">Ziti Console</div>
  <div id="Version" class="version">{{version}}</div>
  <div id="CustomLogo"></div>
  <div class="side-navigator-menu-container">
    @for (group of currentNav.groups; track group) {
      <div class="side-navigator-menu-group">
        <span class="side-navigator-menu-group-label">{{ group.label }}</span>
        @for (item of group.menuItems; track item) {
          <div>
            @if (!item.hidden) {
              <div class="side-navigator-menu-item {{item.className}}" [routerLink]="item.route"
                [ngClass]="{ selected: item.selectedRoutes?.includes(url) }">
                <div class="side-navigator-menu-item-icon">
                  <div class="image" [ngClass]="item.iconClass"></div>
                  @if (item.badgeCount) {
                    <span class="counterBadge">{{ item.badgeCount }}</span>
                  }
                </div>
                <span class="side-navigator-menu-item-label">{{ item.label }}
                  <span class="side-navigator-menu-item-sublabel">{{item.sublabel}}</span>
                </span>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
